<template>
  <div class="Main" @click="removeUserPopup">
    <main-header/>
    <div class="contents-container"
         v-infinite-scroll="getBoardList"
         infinite-scroll-disabled="loading"
         infinite-scroll-distance="300">
      <!-- 배너 -->
      <div class="mrg-top-15 mrg-btm-0 pdd-horizon-30"
           :style='{height:`${swiperHeight}px`}'
           v-if="oBannerInfo.setting.nBannerCnt > 0"
      >
        <mt-swipe :auto="4000">
          <mt-swipe-item v-for="data in oBannerInfo.list" :key="data.nBannerNum">
            <a @click="bannerLink(data)">
              <img :src="data.strBannerUrl"
                   width="100%"
                   @load="imgLoad"/>
            </a>
          </mt-swipe-item>
        </mt-swipe>
      </div>
      <div class="contents-area">
        <div class="boardList-tab">
          <ul>
            <li v-for="data in mainMenuList" :key="data.nMenuNum">
              <a :class="{ disabled : (data.bAllowAccessMenu == false) }"
                 @click="pageMove(data.nMenuNum, data.bAllowAccessMenu)"
              >
                {{ data.strMenuName }}
              </a>
            </li>
          </ul>
        </div>
        <div class="boardList boardFixd clearfix mrg-btm-10"
             v-if="boardNoticeList.length>0 || boardPremiumList.length>0 || boardTopFixList.length>0">
          <ul>
            <!-- 공지사항 -->
            <li v-for="data in boardNoticeList"
                :key="data.oBoard.nBoardIdx"
                class="mrg-top-10"
            >
              <board-top-fix-style :data="data"/>
            </li>
            <!-- 프리미엄 -->
            <li v-for="data in boardPremiumList"
                :key="data.oBoard.nBoardIdx"
                class="mrg-top-10"
            >
              <board-top-fix-style :data="data"/>
            </li>
            <!-- 상단고정 -->
            <li v-for="data in boardTopFixList"
                :key="data.oBoard.nBoardIdx"
                class="mrg-top-10"
            >
              <board-top-fix-style :data="data"/>
            </li>
          </ul>
        </div>
        <!-- 일반게시글 -->
        <div class="boardList clearfix">
          <ul>
            <li v-for="data in boardNormalList" :key="data.oBoard.nBoardIdx">
              <board-list-style :data.sync="data" popup="Y"/>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 하단 메뉴 -->
    <footer class="footer-board">
      <ul>
        <li><a @click="boardListReload"><img src="../../assets/images/bottom-tab-home.png"/></a></li>
        <li><a @click="boardListReload"><img src="../../assets/images/bottom-tab-refresh.png"/></a></li>
        <li><a @click="boardTop"><img src="../../assets/images/bottom-tab-top.png"/></a></li>
        <li><a @click="boardSearchSlideView"><img src="../../assets/images/bottom-tab-search.png"/></a></li>
        <li><a @click="boardWriteAuthCheck('')"><img src="../../assets/images/bottom-tab-write.png"/></a></li>
      </ul>
    </footer>
  </div>
</template>

<script>
import mainHeader from '@/components/mainHeader.vue';
import BoardListStyle from "@/components/boardListStyle";
import BoardTopFixStyle from "@/components/boardTopFixStyle";

export default {
  name: 'Main',
  components: {BoardTopFixStyle, BoardListStyle, mainHeader},
  data() {
    return {
      oBannerInfo: {           // 배너정보
        setting: {
          nBannerCnt: 0
        }
      },
      mainMenuList: [],        // 메인메뉴 리스트
      boardNoticeList: [],     // 공지사항
      boardPremiumList: [],    // 프리미엄
      boardTopFixList: [],     // 상단고정
      boardNormalList: [],     // 일반게시글
      page: 1,                 // 현재 페이지
      loading: false,          // 로딩여부
      listMore: true,          // 추가 페이지 여부
      swiperHeight: 0          // 스와이프 높이
    }
  },
  // 계산된 속성
  computed: {},
  // 감시자
  watch: {
  },
  // $el 생성전
  created() {
    console.group("Main-created")
    this.loginCheck();
    this.$store.commit('setBoardActiveCode', '');
    this.$store.commit('setHistoryUrl', []);
    console.groupEnd()
  },
  // $el 생성후
  mounted() {
    console.group("mounted")
    window.callbackBackKey = this.callbackBackKey;
    this.tokenSendFunc();
    console.groupEnd()
  },
  methods: {
    // APP 뒤로가기
    callbackBackKey() {

      window.Android.exitApp();
    },
    // 초기화
    boardListReload() {
      this.boardNoticeList = [];
      this.boardPremiumList = [];
      this.boardTopFixList = [];
      this.boardNormalList = [];
      this.page = 1;
      this.loading = false;
      this.listMore = true;
      this.getBoardList();
    },
    // 이슈글 목록
    getBoardList() {
      if (!this.listMore) {
        return false;
      }
      this.loading = true;
      let param = {};
      param.nPage = this.page++;
      this.ajaxGetAuth('/api/v1/board/list/issues', param, this.getBoardListResult);
    },
    // 이슈글 목록 결과
    getBoardListResult(response, varParam) {

      if (response.result.code == 0) {
        if(response.maintenance ){
          alert("정기점검중입니다 \n\n페이지가 이동됩니다.")
          window.location.href="http://noti.mobigo.co.kr";
        }
        this.oBannerInfo = response.oBannerInfo;

        // 검색결과가 없을 경우
        if (response.oBoardInfo.setting.nBoardTotalCnt == 0) {
          this.boardNoticeList = [];
          this.boardPremiumList = [];
          this.boardTopFixList = [];
          this.boardNormalList = [];
          this.page = 1;
          return false;
        }

        if (varParam.nPage == 1) {
          this.mainMenuList = response.oMenuInfo.list
        }

        let vm = this;
        response.oBoardInfo.list.forEach(function (key) {
          // 공지사항
          if (key.oBoard.strAtclType === 'NOTICE') {
            vm.boardNoticeList.push(key)
          }
          // 프리미엄
          if (key.oBoard.strAtclType === 'PREMIUM') {
            vm.boardPremiumList.push(key)
          }
          // 상단고정
          if (key.oBoard.strAtclType === 'TOP_FIX') {
            vm.boardTopFixList.push(key)
          }
          // 일반게시글
          if (key.oBoard.strAtclType === 'NORMAL') {
            vm.boardNormalList.push(key)
          }
        })

        // 현재 페이지와 마지막 페이지가 같은경우
        // if (response.oBoardInfo.setting.nNowPage == response.oBoardInfo.setting.nMaxPage) {
        //   this.listMore = false;
        // }

        /**
         * 메인에 오류 발생시 중복으로 호출외는 문제로 1회만 호출되게 수정.
         * @date 22.04.14
         * @type {boolean}
         */
        this.listMore = false;

        if( Object.prototype.hasOwnProperty.call(response, "oEmoticon")){
          this.$store.commit('setEmoticon',response.oEmoticon);
        }
      }

      this.loading = false;
    },
  },
  // $el 해체
  destroyed() {
  }
}
</script>

<style scoped>

</style>
